import React from "react";
import "./shimmer.css"; // Make sure to add the appropriate styles

const Shimmer = ({ width, height }) => {
  return (
    <div
      className="shimmer-wrapper"
      role="shimmer-wrapper"
      style={{ width, height }}
    >
      <div className="shimmer"></div>
    </div>
  );
};

export default Shimmer;
